import type { FC } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import type { MyLocale } from "@i18n";
import { useI18n } from "next-rosetta";

import EmptySpace from "./EmptySpace";

interface NewUserProps {
	onClick?: () => void;
	enableNodeCreation?: boolean;
}

const NewUser: FC<NewUserProps> = ({ enableNodeCreation, onClick }) => {
	const i18n = useI18n<MyLocale>();
	const { t } = i18n;
	return (
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			flexDirection="column"
			minHeight="30vh"
		>
			<EmptySpace />
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				flexDirection="column"
				marginTop={4}
			>
				<Typography>{t("nodes.empty")}</Typography>
				{enableNodeCreation && (
					<Button variant="contained" onClick={onClick} sx={{ marginTop: 2 }}>
						{t("nodes.createANode")}
					</Button>
				)}
			</Box>
		</Box>
	);
};

export default NewUser;
